import { ApplicationPermissions } from '@uw/core/application-permission';
import { Roles } from '@uw/core/enums/role.enum';
import { IMenuConfig } from '@uw/themes/models/menu.model';

const repostingPermissions = [
  ApplicationPermissions.reportAdHoc,
  ApplicationPermissions.reportAllCanvassers,
  ApplicationPermissions.reportCampaignHierarchy,
  ApplicationPermissions.reportCanvasser,
  ApplicationPermissions.reportCCCReport,
  ApplicationPermissions.reportCashChequeCreditCardPaidUA,
  ApplicationPermissions.reportCashChequeCreditCardReceivedWA,
  ApplicationPermissions.reportCharityAllocationSummary,
  ApplicationPermissions.reportCompanyCampaignExtractedAndUnExtracted,
  ApplicationPermissions.reportCompanyCampaignExtractedReconciliation,
  ApplicationPermissions.reportCompanyCampaignHierarchy,
  ApplicationPermissions.reportCompanyCampaignUnpaid,
  ApplicationPermissions.reportCompanyCampaignWorkplace,
  ApplicationPermissions.reportCompanyLevelPayrollDeductions,
  ApplicationPermissions.reportCorpAllCanvassers,
  ApplicationPermissions.reportCorpCampaignHierarchy,
  ApplicationPermissions.reportCorpEmployeeStatus,
  ApplicationPermissions.reportDailyStatus,
  ApplicationPermissions.reportDecidedUnDecidedFinancial,
  ApplicationPermissions.reportDecidedUnDecidedNonFinancial,
  ApplicationPermissions.reportEditAdHoc,
  ApplicationPermissions.reportEmployeeStatus,
  ApplicationPermissions.reportEmployeeTransaction,
  ApplicationPermissions.reportFairShare_Co,
  ApplicationPermissions.reportFairShare_Internal,
  ApplicationPermissions.reportLeadershipStatus,
  ApplicationPermissions.reportLeadershipSummary,
  ApplicationPermissions.reportLocalResults,
  ApplicationPermissions.reportLocalUWResults,
  ApplicationPermissions.reportLocalUWResultsReportNationalCampaigns,
  ApplicationPermissions.reportLocalUWResultsReportNationalCampaigns_FR,
  ApplicationPermissions.reportOverallStatus,
  ApplicationPermissions.reportPaymentGatewayRecDetail,
  ApplicationPermissions.reportPaymentGatewayRecSum,
  ApplicationPermissions.reportPayrollDeductions,
  ApplicationPermissions.reportKioskSummary,
  ApplicationPermissions.reportSurveyQuestion,
  ApplicationPermissions.reportSweepstakes,
  ApplicationPermissions.uwReporting,
  ApplicationPermissions.reportUpsellStatus,
];

const campaignManagementMenuPermissions = [
  ApplicationPermissions.wrkPlCompanyLevel,
  ApplicationPermissions.unitedWayAdmin,
  ApplicationPermissions.wrkPlCampaignSetup,
  ApplicationPermissions.wrkPlCompanyLevel,
  ApplicationPermissions.unitedWayAdmin,
  ApplicationPermissions.wrkPlUserSetup,
  ApplicationPermissions.wrkPlDataEntry,
  ApplicationPermissions.uwCampaignCreate,
  ApplicationPermissions.uwCompanyCampaignSetup,
  ApplicationPermissions.wrkPlEmployeeGroupMgmt,
  ApplicationPermissions.wrkPlCampaignDashboardOnly,
];
export class MenuConfig {
  public defaults: IMenuConfig = {
    aside: [
      {
        title: 'Reports-RA',
        // root: true,
        direct: true,
        permission: [ApplicationPermissions.reportAdmin],
        page: '/private/report/ra',
        translate: 'menu.aside.reports',
      },
      {
        title: 'United Way Setup',
        root: true,
        page: '/profiles',
        permission: [
          ApplicationPermissions.uwUserSetup,
          ApplicationPermissions.uwCampaignProfile,
          ApplicationPermissions.uwUtilities,
        ],
        restrictedRoles: [Roles.ReportAdministrator],
        translate: 'menu.aside.united_way_setup',
        submenu: [
          {
            title: 'united_way_admin',
            page: '/private/uwsetup/admin',
            permission: [ApplicationPermissions.uwUserSetup],
            translate: 'menu.aside.united_way_setup_inner.united_way_admin',
          },
          {
            title: 'tax_calculator_matrix',
            page: '/private/uwsetup/tax',
            permission: [ApplicationPermissions.uwUtilities],
            translate:
              'menu.aside.united_way_setup_inner.tax_calculator_matrix',
          },
          {
            title: 'uw_settings',
            permission: [ApplicationPermissions.uwUtilities],
            page: '/private/uwsetup/settings',
            translate: 'menu.aside.united_way_setup_inner.uw_settings',
          },
          {
            title: 'profiles',
            permission: [ApplicationPermissions.uwCampaignProfile],
            page: '/private/profile/list',
            translate: 'profile.profiles',
          },
          {
            title: 'content-management',
            permission: [ApplicationPermissions.uwUtilities],
            page: '/private/uwsetup/content-management',
            translate: 'common.content_management',
          },
          {
            title: 'catalogue-management',
            permission: [ApplicationPermissions.uwUtilities],
            page: '/private/uwsetup/catalogue-management',
            translate: 'common.catalogue_management',
          },
          {
            title: 'sso-config',
            permission: [ApplicationPermissions.uwSSOConfigurationSetup],
            page: '/private/uwsetup/sso-config',
            translate: 'menu.aside.united_way_setup_inner.sso_config',
          },
        ],
      },
      {
        title: 'campaign_management',
        root: true,
        key: 'campaign_management', // use for dynamic hide and show
        page: '/campaign_management',
        restrictedRoles: [Roles.ReportAdministrator],
        permission: [...campaignManagementMenuPermissions],
        translate: 'menu.aside.campaign_management',
        submenu: [
          {
            title: 'select_company',
            permission: [
              ApplicationPermissions.wrkPlCompanyLevel,
              ApplicationPermissions.unitedWayAdmin,
            ],
            page: '/private/company',
            translate: 'menu.aside.campaign_mgnt_inner.select_company',
          },
          {
            title: 'select_campaign',
            page: '/private/campaign',
            permission: [
              ApplicationPermissions.wrkPlCampaignSetup,
              ApplicationPermissions.wrkPlCompanyLevel,
              ApplicationPermissions.unitedWayAdmin,
              ApplicationPermissions.wrkPlUserSetup,
              ApplicationPermissions.wrkPlDataEntry,
              ApplicationPermissions.uwCampaignCreate,
              ApplicationPermissions.uwCompanyCampaignSetup,
              ApplicationPermissions.wrkPlEmployeeGroupMgmt,
              ApplicationPermissions.wrkPlCampaignDashboardOnly,
            ],
            translate: 'menu.aside.campaign_mgnt_inner.select_campaign',
          },
          {
            title: 'employee_search',
            page: '/private/employee',
            translate: 'menu.aside.campaign_mgnt_inner.employee_search',
            permission: [ApplicationPermissions.unitedWayAdmin],
          },
          {
            title: 'transaction_search',
            page: '/private/transaction',
            translate: 'menu.aside.campaign_mgnt_inner.transaction_search',
            permission: [ApplicationPermissions.unitedWayAdmin],
          },
        ],
      },
      {
        title: 'canvasser email',
        direct: true,
        permission: [
          ApplicationPermissions.caEmail,
          // ApplicationPermissions.canvasserAdmin,
        ],
        page: '/private/canvasser/canvasser-email',
        translate: 'menu.aside.email',
      },
      {
        title: 'report',
        root: true,
        key: 'report', // use for dynamic hide and show
        page: '/report',
        // restrictedRoles: [Roles.ReportAdministrator],
        translate: 'menu.aside.reports',
        permission: [
          ApplicationPermissions.unitedWayAdmin,
          ApplicationPermissions.reportAdHoc,
          ApplicationPermissions.reportAllCanvassers,
          ApplicationPermissions.wrkPlReporting,
          ...repostingPermissions,
        ],
        submenu: [
          {
            title: 'report_company',
            permission: [
              ApplicationPermissions.wrkPlCompanyLevel,
              ApplicationPermissions.unitedWayAdmin,
              // ...repostingPermissions
            ],
            page: '/private/report/company',
            translate: 'menu.aside.campaign_mgnt_inner.select_company',
          },
          {
            title: 'report_campaign',
            page: '/private/report/campaign',
            permission: [
              ApplicationPermissions.wrkPlCampaignSetup,
              ApplicationPermissions.wrkPlCompanyLevel,
              ApplicationPermissions.unitedWayAdmin,
              ApplicationPermissions.wrkPlUserSetup,
              ApplicationPermissions.wrkPlDataEntry,
              ApplicationPermissions.uwCampaignCreate,
              ApplicationPermissions.uwCompanyCampaignSetup,
              ApplicationPermissions.wrkPlEmployeeGroupMgmt,
              ...repostingPermissions,
            ],
            translate: 'menu.aside.campaign_mgnt_inner.select_campaign',
          },
          {
            title: 'report_uw',
            permission: [
              ApplicationPermissions.reportCharityAllocationSummary,
              ApplicationPermissions.reportLocalUWResultsReportNationalCampaigns,
              ApplicationPermissions.reportLeadershipSummary,
              ApplicationPermissions.reportLocalResults,
              ApplicationPermissions.reportOverallStatus,
              ApplicationPermissions.reportPaymentGatewayRecSum,
              ApplicationPermissions.reportPaymentGatewayRecDetail,
              ApplicationPermissions.unitedWayAdmin,
            ],
            page: '/private/report/uw',
            translate: 'menu.aside.reports_inner.uw_reports',
          },
        ],
      },
      // {
      //   title: 'reports',
      //   root: true,
      //   page: '/reports',
      //   translate: 'menu.aside.reports',
      //   permission: [
      //     ApplicationPermissions.unitedWayAdmin,
      //     ApplicationPermissions.reportAdHoc,
      //     ApplicationPermissions.reportAllCanvassers,
      //     ApplicationPermissions.wrkPlReporting
      //   ]
      // },
      {
        title: 'upload_extract',
        root: true,
        restrictedRoles: [Roles.ReportAdministrator],
        permission: [ApplicationPermissions.uwUploadExtract],
        translate: 'menu.aside.upload_extract',
        submenu: [
          {
            title: 'file_upload',
            page: '/private/file_upload',
            translate: 'menu.file_upload',
            permission: [ApplicationPermissions.uwUploadExtract],
          },
          {
            title: 'campaign_extract',
            page: '/private/campaign_extract',
            translate: 'menu.campaign_extract',
            permission: [ApplicationPermissions.uwUploadExtract],
          },
          // {
          //   title: 'view_extract_business_rule',
          //   page: '/upload_extract/view_extract_business_rule',
          //   translate:
          //     'menu.view_extract_business_rule',
          // },
          {
            title: 'view_redo_past_extract',
            page: '/private/past_extracts',
            translate: 'menu.view_redo_past_extracts',
            permission: [ApplicationPermissions.uwUploadExtract],
          },
          // {
          //   title: 'view_redo_past_extract',
          //   page: '/upload_extract/view_redo_past_extract',
          //   translate: 'menu.view_redo_past_extracts',
          // },
        ],
      },
      // {
      //   title: 'data_entry',
      //   root: true,
      //   permission: [
      //     ApplicationPermissions.uwExternalDataEntry,
      //     ApplicationPermissions.unitedWayAdmin,
      //   ],
      //   page: '/data_entry',
      //   translate: 'menu.data_entry',
      // },
    ],
  };

  public get configs(): any {
    return this.defaults;
  }
}
